import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ThirdPartyForm_Person_Create_Mutation = graphql(`
  mutation ThirdPartyForm_Person_Create(
    $person: PersonInput!
    $versionData: VersionDataInput
  ) {
    createPerson(doc: $person, versionData: $versionData) {
      _id
    }
  }
`);

export type PersonInput = VariablesOf<
  typeof ThirdPartyForm_Person_Create_Mutation
>['person'];

export type ThirdPartyForm_Person_Create_Result = ResultOf<
  typeof ThirdPartyForm_Person_Create_Mutation
>;

export const useCreatePersonMutation = () =>
  useGraphQLMutation(ThirdPartyForm_Person_Create_Mutation);
